var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import PropTypes from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";

var SUPPORTED_COLORS = ["primary", "info", "success", "warning", "danger"];

var SIZE_MAP = {
  xsmall: "18px",
  small: "24px",
  medium: "36px",
  large: "48px",
  xs: "18px",
  sm: "24px",
  md: "36px",
  lg: "48px"
};

var Icon = (_temp = _class = function (_Component) {
  _inherits(Icon, _Component);

  function Icon() {
    _classCallCheck(this, Icon);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Icon.prototype.render = function render() {
    var _classNames;

    var _props = this.props,
        color = _props.color,
        name = _props.name,
        size = _props.size,
        style = _props.style;


    var colorIsSupported = SUPPORTED_COLORS.indexOf(color) > -1;

    var className = classNames((_classNames = {
      "material-icons": true
    }, _classNames[this.props.className] = !!this.props.className, _classNames["color-" + color] = colorIsSupported, _classNames));

    var fontSize = typeof size === "number" ? size + "px" : SIZE_MAP[size] || size;

    var styles = _extends({}, fontSize && { fontSize: fontSize }, !colorIsSupported && { color: color }, style);

    return React.createElement(
      "i",
      {
        className: className,
        style: Object.keys(styles).length ? styles : undefined
      },
      name
    );
  };

  return Icon;
}(Component), _class.defaultProps = {
  style: {}
}, _temp);
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Additional wildcard classes that can be appended to base class
   */
  className: PropTypes.string,
  /**
   * Name of the icon from <a href="https://material.io/tools/icons/">Material Icons</a> – e.g. "flight_takeoff", "trending_up", "arrow_upward"
   */
  name: PropTypes.string.isRequired,
  /**
   * One of: "primary", "info", "success", "warning", "danger" or any web supported color value
   */
  color: PropTypes.string,
  /**
   * One of: "xs", "xsmall", "sm", "small", "md", "medium", "lg", "large" or the number value "18", "24", "36", "48".
   * Generally defaults to "small" or "24px", but this may be different depending on the context.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  /**
   * Object for adding additional styles to default styles via Javascript
   */
  style: PropTypes.object
} : {};


export default Icon;